export class AwsEksNamespaceSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<InventorySnapshotVolume>",
            "format": ""
        },
        {
            "name": "secretsCount",
            "baseName": "secretsCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEksNamespaceSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
